import React from "react";
import UserInfoSection from "../Components/UserInfoSection";
import LoginManage from "./LoginManage";
import { useDispatch, useSelector } from "react-redux";

function ManageLogin() {
  return (
    <div className="userdb-two-secs">
      <UserInfoSection />
      <LoginManage />
    </div>
  );
}

export default ManageLogin;
